import {
    Dispatch,
    useEffect,
    useRef,
    useState,
} from 'react'

type VisibilityObserver = {
    isActive: boolean
    isVisible: undefined | boolean
    ref: undefined | Element
    setRef: Dispatch<Element | undefined>
}

export const useVisibilityObserver = (): VisibilityObserver => {
    const [isVisible, setIsVisible] = useState<boolean>()
    const [isActive, setIsActive] = useState<boolean>(isVisible ?? false)
    const [ref, setRef] = useState<Element>()

    const prevRef = useRef<undefined | Element>()

    const observer = useRef<IntersectionObserver>()

    useEffect(() => {
        observer.current = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {threshold: 1})
    }, [])

    useEffect(() => {
        if (ref) {
            observer.current?.observe(ref)
        } else if (prevRef.current) {
            observer.current?.unobserve(prevRef.current)
            setIsVisible(undefined)
            setIsActive(false)
        }

        prevRef.current = ref

        return () => observer.current?.disconnect()
    }, [ref])

    useEffect(() => {
        if (!isActive) {
            setIsActive(!!prevRef.current)
        }
    }, [isVisible])

    return {
        isActive,
        isVisible,
        ref,
        setRef,
    }
}
